import React, { useState, useCallback, useEffect } from "react";
import { Col, Row, Container, Image, Form } from "react-bootstrap";
import { SaveAsPdf } from "../../reusableComponent";
import { LoaderPage } from "../../../component/Loader";
import { connect } from "react-redux";

// header and footer
import { PdfHeader } from "./pdfHeader";
import { PdfFooter } from "./pdfFooter";

// pages
import { FirstPage } from "./firstPage";
import { SecondPage } from "./secondPage";
import { ThirdPage } from "./thirdPage";

// actions
import { chartsClearLoadedAction } from "../../../actions/reports.action";

const DownloadChartsComponent = React.memo(({ chartsReducer }) => {
  // for quality
  const [quality, setState] = useState(1);
  const onChange = useCallback(e => {
    setState(e.target.value);
  });

  // for download button enable disable
  let values = [];
  Object.values(chartsReducer).forEach(value => {
    Object.values(value).forEach(chartLoader => {
      if (!chartLoader) {
        values.push(chartLoader);
      }
    });
  });

  // clear charts state
  useEffect(() => {
    return () => {
      chartsClearLoadedAction();
    };
  }, []);

  return (
    <section className="pdf-container">
      <LoaderPage loading={false} />
      <Row lg={6}>
        <Col lg={2}>
          <SaveAsPdf
            elementId={"section-pdf"}
            name="PMG_Report.pdf"
            quality={quality}
            disabled={values.length}
            isPdfReadyForDownload={values.length}
          />
        </Col>
        <Col lg={4}>
          <Form.Control
            as="select"
            onChange={onChange}
            className="quality-input-tag"
          >
            <option value=""> - Select Quality - </option>
            {[1, 2, 3, 4, 5].map(value => {
              return <option value={value}>{value}</option>;
            })}
          </Form.Control>
        </Col>
      </Row>

      <Container id="section-pdf" className={"chart_container"}>
        {/* first page of pdf */}
        <Row id="mis-report" className="justify-content-md-center pdf-section">
          <PdfHeader />
          <FirstPage />
          <PdfFooter />
        </Row>

        {/* second page of pdf */}
        <Row
          id="mis-report"
          className="justify-content-md-center pdf-section pdf-second-page"
        >
          <PdfHeader />
          <SecondPage />
          <PdfFooter />
        </Row>

        {/* third page of pdf */}
        <Row
          id="mis-report"
          className="justify-content-md-center pdf-section pdf-third-page"
        >
          <PdfHeader />
          <ThirdPage />
          <PdfFooter />
        </Row>
      </Container>
    </section>
  );
});

function mapStateToProps(state) {
  return {
    chartsReducer: state.chartsReducer
  };
}

const DownloadCharts = connect(
  mapStateToProps,
  null
)(DownloadChartsComponent);
export { DownloadCharts };
